import { getDefaultPathVar } from '../../utils/utils';

const trackingConfig = () => {
  const { localeLanguage: language, localeCountry: country } = getDefaultPathVar();
  return {
    page: {
      page_url: window.location.href,
      language,
      country,
    },
  };
};

export default trackingConfig;
